export default {
  props: {
    extraCssClass: {
      type: String,
      "default": ''
    }
  }
};